import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../../config/apiClientConfig';

const planDetailSchema = z.object({
	name: z.string(),
	code: z.string(),
	topHospitalList: z.string(),
	insuranceCompanyId: z.number(),
	annualLimitCover: z.string(),
	annualLimitPharmacy: z.string(),
	coPaymentsInPatient: z.string(),
	coPaymentsDiagnostic: z.string(),
	coPaymentsPharmacy: z.string(),
	coPaymentsLabTests: z.string(),
	coPaymentsOPConsultations: z.string(),
	coPaymentsPhysioTreatment: z.string(),
	coPaymentsMaternity: z.string(),
	coPaymentsDental: z.string(),
	coPaymentsOptical: z.string(),
	policyWordingUrlEn: z.string(),
	policyWordingUrlAr: z.string(),
	planTypeIds: z.array(z.number()),
	benefitSummary: z.array(z.string()),
	networkGroupId: z.number(),
	planKeyBenefits: z.array(z.object({ benefitCategoryId: z.number(), isKeyBenefit: z.boolean() })),
	planBenefits: z.array(z.object({ benefitId: z.number() })),
	planNetworks: z.array(z.any()),
	planExclusionMappings: z.array(z.object({ planExclusionId: z.number() })),
	planNetworkCounts: z.array(z.object({ facilityTypeId: z.number(), count: z.number(), display: z.boolean() })),
});

const getPlanDetailsResponseSchema = planDetailSchema;

const getPlanDetails = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/admin/plan/plandetail',
		method: 'GET',
		responseSchema: getPlanDetailsResponseSchema,
		requestSchema: z.null().nullish(),
		requestParameters: { planId: ['required', 'number'] },
		transformResponse: (response) => response.data.planDetail,
	});

export default getPlanDetails;

export type GetPlanDetailsAPIResponse = TypeOfAPIResponse<ReturnType<typeof getPlanDetails>>;

export type GetPlanDetailsError = TypeOfAPIError<ReturnType<typeof getPlanDetails>>;
